import { IWordBank, WordBankCategory } from 'types'

export const top5InitialState = {
  isLoading: {} as { [key in WordBankCategory]?: boolean },
  isSubmitting: {} as { [key in WordBankCategory]?: boolean },
  isLoadingCategories: false,
  rules: {
    [WordBankCategory.Xfactor]: { maxItems: 5 },
    [WordBankCategory.TalentTags]: { maxItems: 10 },
    [WordBankCategory.CompanyDescriptor]: { maxItems: 5 }
  },
  wordBanks: {} as {
    [WordBankCategory.Xfactor]: IWordBank[]
    [WordBankCategory.TalentTags]: IWordBank[]
    [WordBankCategory.CompanyDescriptor]: IWordBank[]
  }
}

export type Top5State = typeof top5InitialState
